var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrap",staticClass:"lazy-list",style:({ height: `${_vm.height}px` })},[_vm._t("default"),_c('mugen-scroll',{attrs:{"handler":_vm.fetchHandler,"should-handle":!_vm.pageLoading && !_vm.allDataLoaded,"scroll-container":"wrap"}},[_c('scroll-loader',{attrs:{"all-data-loaded":_vm.allDataLoaded}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }